import {
    GetProcessDesignerPath,
} from './PathHelper';

export const HandleRouteToProcessDesigner = (props, organizationId, projectId, processId) => {
    props.history.push(GetProcessDesignerPath(organizationId, projectId, processId));
}